import { render } from "./AlertSound.vue?vue&type=template&id=1c1fa552&scoped=true&ts=true"
import script from "./AlertSound.vue?vue&type=script&lang=ts"
export * from "./AlertSound.vue?vue&type=script&lang=ts"

import "./AlertSound.vue?vue&type=style&index=0&id=1c1fa552&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c1fa552"]])

export default __exports__